import Legal from './container';

export default Legal;
